import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/orderFrequencyReport'
import Component from 'components/Reports/OrderFrequencyReport'

export default createListViewContainer({ actions, selectors: selectors.orderFrequencyReport })(Component)
